<template>
  <div class="van-page">
    <h3 style="width: 100%;text-align: center;font-weight: 500;font-size: 16px;margin-top: 0px;padding-top: 16px;">证照详情
    </h3>
    <div class="describe-container">
      <div class="item">
        <div class="title">项目代码：</div>
        <div class="content">{{ code.get('projectCode') }}</div>
      </div>
      <div class="item">
        <div class="title">项目名称：</div>
        <div class="content">{{ title }}</div>
      </div>
    </div>
    <div class="stage-container">
      <div class="stage" v-for="stageItem in stage" :key="stageItem.stageName">
        <h3 class="stage-title">{{ stageItem.stageName }}</h3>
        <div class="item" v-for="(item2, index) in stageItem.itemInfo" :key="item2.itemCode">
          <div class="title-container">
            <div class="content">{{ index + 1 + '.&nbsp;&nbsp;事项名称：' + item2.itemName }}</div>
          </div>
          <div class="qr-container">
            <div class="qr">
              <img :src="item2.imgUrl" alt="">
              <div class="name">{{ item2.qrName }}</div>
            </div>
          </div>
          <el-divider></el-divider>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import * as qrCode from 'qrcode'
import { getStageItemLicenceListByProjectNo } from '@/api/interface/license.js'
export default {
  name: 'licenseDetail',
  components: {
  },
  data() {
    return {
      code: null,
      title: '',
      stage: []
    }
  },
  created() {
    try {
      const href = location.href
      this.code = new Map()
      if (href.includes('?')) href.split('?')[1].split('&').forEach(item => {
        const temp = item.split('=')
        this.code.set(temp[0], temp[1].split('#')[0].includes('%') ? decodeURIComponent(temp[1].split('#')[0]) : temp[1].split('#')[0])
      });
    } catch (err) {
      console.log(err);
    }
  },
  methods: {
    async getData() {
      const result = await getStageItemLicenceListByProjectNo({
        projectNo: this.code.get('projectCode'),
        certificateType: '001',
        certificateNo: this.code.get('socialCode'),
      })
      this.title = result.data.projectName
      this.stage = await Promise.all(JSON.parse(result.data.stageInfo).map(async item => {
        item.itemInfo.forEach(async item2 => {
          item2.imgUrl = await qrCode.toDataURL(item2.qrUrl)
        })
        return item
      }))
      console.log(this.stage);
    }
  },
  mounted() {
    this.getData()
  }
}
</script>
<style lang="less" scoped>
.describe-container {
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 16px;

  .item {
    display: flex;
    font-size: 16px;

    .title {
      width: 80px;
    }
  }
}

.stage-container {
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 16px;

  .stage {
    display: flex;
    flex-direction: column;
    gap: 16px;

    .stage-title {
      font-size: 16px;
      color: white;
      background-color: #4371fa;
      width: fit-content;
      padding: 4px 16px;
    }

    .item {
      font-size: 16px;

      .qr-container {
        display: flex;
        justify-content: center;
        align-items: center;

        .qr {

          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
        }
      }
    }
  }
}

.van-page {
  height: 100%;
  width: 100vw;
  background: linear-gradient(135deg, rgba(210, 236, 255, 1) 0%, white 6%, white 100%);
  padding-bottom: 70px;
  position: relative;
}

.van-container {
  padding: 16px 16px;
  background-color: white;
  width: 96%;
  margin-left: 2%;
  border-radius: 15px;
}

::v-deep {
  .van-nav-bar {
    background: none;
  }
.el-divider{
  background-color: #427afa;
}
  .van-cell {
    margin-bottom: 12px;
    border-radius: 8px;

    .van-cell__title {
      padding-left: 5px;
      font-weight: 500;
    }
  }
}

.previewContainer {
  position: absolute;
  width: 100vw;
  height: 100vh;
  left: 0;
  top: 0;
  background-color: rgba(0, 0, 0, 0.8);

  .img {
    position: absolute;
    left: 50%;
    top: 35%;
    width: 70%;
    aspect-ratio: 1;
    transform: translate(-50%, -70%);

  }
}

.itemContainer {
  display: flex;
  flex-direction: column;
  width: 100vw;
  height: fit-content;

  .item {
    width: 90%;
    margin-left: 5%;
    height: fit-content;
    min-height: 80px;
    // border-radius: 10px;
    background-color: white;
    margin-top: 10px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    padding: 15px 0;
    border-bottom: 1px solid #eae7e7;

    .content {
      width: 100%;
      margin-left: 0px;

      h4 {
        margin-top: 0px;
      }

      .assist {
        font-weight: 200;
        color: #666;
        line-height: 30px;
      }

      .xmfm {
        float: left;
        background-color: #ecf5ff;
        height: 32px;
        padding: 0 10px;
        color: #409eff;
        border: 1px solid #d9ecff;
        border-radius: 4px;
        box-sizing: border-box;
        white-space: nowrap;
        font-weight: 600;
      }

      .right {

        float: right;
        color: #888686;
      }
    }

    .code {
      display: flex;
      align-items: center;
      justify-content: center;

      img {
        width: 100%;
        height: 100%;
      }
    }

    i {
      width: 10%;
      text-align: right;
    }
  }
}</style>
